<script lang="ts" setup>
import { computed } from "vue";

import date from "@/libs/date";
import { format } from "@/libs/amount.ts";

import { PencilIcon, TrashIcon } from "@heroicons/vue/24/outline";
import { ArrowPathClockIcon } from "@sidekickicons/vue/24/outline";
import type Transaction from "@/classes/Transaction.ts";

const emit = defineEmits(["edit", "remove"]);

const props = defineProps<{ item: Transaction }>();

const color = computed(() => {
  return props.item.type === "expense" ? "text-red-500" : "text-gray-500";
});

const isInPast = computed(() => date(props.item.date).isBefore(new Date()));

const onEdit = () => emit("edit");

const onRemove = () => emit("remove");
</script>

<template>
  <tr :class="[{ 'opacity-50': isInPast }, 'text-sm text-gray-500 even:bg-gray-50']">
    <td class="flex flex-row gap-x-2 items-center relative py-4 px-3">
      {{ date(item.date).format("L") }}
      <p v-show="item.recurrence !== null" :title="item.recurrence?.toText()">
        <ArrowPathClockIcon class="size-4"></ArrowPathClockIcon>
      </p>
    </td>
    <td class="hidden px-3 py-4 sm:table-cell">{{ item.name }}</td>
    <td class="hidden px-3 py-4 md:table-cell">{{ item.description }}</td>
    <td :class="[color, 'px-3 py-4 text-right text-sm']">
      {{ format(item.amount, item.currency) }}
    </td>
    <td :class="[item.balance! < 0 ? 'text-red-500' : 'text-gray-500', 'px-3 py-4 text-right']">
      {{ format(item.balance) }}
    </td>
    <td :class="['relative py-4 pl-3 text-right']"></td>
    <td class="flex flex-row items-center space-x-2 pr-3">
      <PencilIcon class="w-4 h-4 text-indigo-500" @click="onEdit"></PencilIcon>
      <TrashIcon class="w-4 h-4 text-red-500" @click="onRemove"></TrashIcon>
    </td>
  </tr>
</template>
